import React from "react";
import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Rate from "../../../components/Rating";
const Review = ({ reviewData , userToggle}) => {
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  //style={{background :'linear-gradient(180deg, #086788 0%, rgba(45, 161, 201, 0.99) 100%)'}}
  return (
    
      !userToggle ?  
      <div className="flex flex-col p-2.5 rounded-2xl" >
        <div className="rounded-2xl h-[450px]  bg-[#E2F8FF] p-4 md:p-6" >
          <div className="mb-5 flex w-full flex-row justify-start items-center">
            {reviewData?.user_image_url ? (
              <div className="relative cursor-pointer" onClick={(e)=>{if(reviewData?.linkedin_url?.length > 0) {window.open(reviewData?.linkedin_url, "_blank") }} }>
                <div className="w-full">
                    <img
                      src={reviewData?.user_image_url}
                      className=" h-14 w-14 md:h-[80px] md:w-[80px] ring ring-[#0654A2] rounded-full "
                      width={window.innerWidth > 758 ? '80px': '56px'}
                      height={window.innerWidth > 758 ? '80px': '56px'}
                      alt="profile image"
                    />
                </div>
                {reviewData?.linkedin_url?.length > 0 && <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={'https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400'}
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                  className=" h-5 md:h-6 md:left-14 md:top-14 absolute left-9 top-9"
                />}
              </div>
            ) : (
              <FontAwesomeIcon
                icon={faUserCircle}
                className={"mt-2 h-12 w-14 rounded-full"}
              />
            )}
            <div className=" flex flex-1 flex-col ml-3 md:ml-4">
              <h1 className="text-sm md:text-lg font-semibold  text-black" style={{
                lineHeight: '20px'
              }}>{reviewData?.testimonial_title}</h1>
              <h4 className="text-xs md:text-sm mt-1 text-stone-500">
               - {reviewData?.name}
              </h4>
            </div>
          </div>
          {/* <div className=" -mt-2 md:-mt-2">
            <Rate
                rating={5}
                color={{
                  filled: "#FFD700",
                  unfilled: "#808080",
                }}
                count={5}
                size={"lg"}
                isReadOnly={true}
              />
          </div> */}
          <div className=" mt-2 md:mt-4 md:leading-5 self-center text-sm md:text-base text-pricing_blue">
          {reviewData?.testimonial}
          </div>
        </div>
      </div>
      :
      <div className="flex  w-full  flex-col  rounded-2xl" style={{background :'linear-gradient(180deg, #086788 0%, rgba(45, 161, 201, 0.99) 100%)'}}>
        <div className="rounded-2xl h-[450px] bg-[#E2F8FF] p-4 md:p-6" >
          <div className="mb-5 flex w-full flex-row justify-start items-center">
            {reviewData?.user_image_url ? (
              <div className="relative cursor-pointer" onClick={(e)=>{if(reviewData?.linkedin_url?.length > 0) {window.open(reviewData?.linkedin_url, "_blank") }} }>
                <div className="w-full">
                    <img
                      src={reviewData?.user_image_url}
                      className=" h-14 w-14 md:h-[80px] md:w-[80px] ring ring-[#0654A2] rounded-full "
                      width={window.innerWidth > 758 ? '80px': '56px'}
                      height={window.innerWidth > 758 ? '80px': '56px'}
                      alt="profile image"
                    />
                </div>
                {reviewData?.linkedin_url?.length > 0 && <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={'https://assets.learntube.ai/files/Content_player/LinkdIn.png?updatedAt=1681563676400'}
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                  className=" h-5 md:h-6 md:left-14 md:top-14 absolute left-9 top-9"
                />}
              </div>
            ) : (
              <FontAwesomeIcon
                icon={faUserCircle}
                className={"mt-2 h-12 w-14 rounded-full"}
              />
            )}
            <div className=" flex flex-1 flex-col ml-3 md:ml-4">
              <h1 className="text-sm md:text-lg font-semibold  text-black" style={{
                lineHeight: '20px'
              }}>{reviewData?.testimonial_title}</h1>
              <h4 className="text-xs md:text-sm mt-1 text-stone-500">
               - {reviewData?.name}
              </h4>
            </div>
          </div>
          {/* <div className=" -mt-2 md:-mt-2">
            <Rate
                rating={5}
                color={{
                  filled: "#FFD700",
                  unfilled: "#808080",
                }}
                count={5}
                size={"lg"}
                isReadOnly={true}
              />
          </div> */}
          <div className=" mt-2 md:mt-4 md:leading-5 self-center text-sm md:text-base text-pricing_blue">
          {reviewData?.testimonial}
          </div>
        </div>
    </div>

  );
};

export default Review;
